export default __webpack_public_path__ + "static/media/BKM_de_v2__Web_farbig.1f096161.svg";